module.exports = __webpack_public_path__ + "static/media/iconEditActive.eec1659e.svg";